import { createContext } from 'react';

type LoginState = {
  email?: string | null;
  password?: string | null;
  country?: string | null;
  countryCode?: string | null;
  phoneNumber?: string | null;
  resetPasswordToken?: string | null;
};
export type LoginContextType = {
  loginState: LoginState;
  setLoginState: (loginState: LoginState) => void;
  isInvalidMfaState?: boolean;
};

export const InitialLoginState: LoginContextType['loginState'] = {
  email: null,
  password: null,
  country: null,
  countryCode: null,
  phoneNumber: null,
  resetPasswordToken: null,
};

export const LoginContext = createContext<LoginContextType>({
  loginState: {},
  setLoginState: () => {},
});
